import getLang from 'I18n/utils/getLang';
import { useLessonContentById } from '../lessons';
import { useTrack } from '../tracks';
export const useLearningContentType = ({
  lessonId,
  trackId,
  language,
  contentId
}) => {
  const content = useLessonContentById({
    lessonId: Number(lessonId),
    contentId: Number(contentId),
    language: language || getLang()
  });
  const {
    track
  } = useTrack(Number(trackId), language, !trackId);
  let type = 'CHAPTER';

  if (content) {
    type = content.contentType;
  } else if (track && track.introVideoId && Number(track.introVideoId) === Number(contentId)) {
    type = 'VIDEO';
  }

  return type;
};